import { load } from '@helpers/googleMaps';
import svgPin from '@img/icons/background/pin.svg?url';
import * as React from 'react';
import S from './MapArea.styles';
const MapArea = ({ position, site }) => {
    const refMapContainer = React.useRef(null);
    React.useEffect(() => {
        doAsync();
        async function doAsync() {
            if (!refMapContainer.current) {
                return;
            }
            // Ensure SDK is loaded.
            const googleApi = await load(site);
            // Create new map instance.
            const map = new googleApi.maps.Map(refMapContainer.current, {
                center: position,
                zoom: 15,
            });
            // Add location marker
            new googleApi.maps.Marker({
                icon: svgPin,
                map,
                position: position,
            });
        }
    }, [position]);
    return React.createElement(S.Container, { ref: refMapContainer });
};
export default MapArea;
